module.exports = {
  apiHost: "https://api.sanctuaryrise.sensoreal.app",
  assetsHost: "https://assets.sanctuaryrise.sensoreal.app",
  brandName: "Sanctuary Rise",
  header: {
    text: { en: "Your Sanctuary Rise Selections" },
    logo: "",
    companyLogo: "",
    color: "#fff",
  },
  langs: [{ code: "en", dir: "ltr" }],
  style: {
    primaryColor: "#0c1636",
    textColor: "#fff",
    font: "avenir",
  },
  contact: {
    website: "",
    address: "",
    phone: "",
    email: "",
  },
  links: {
    privacy: "",
    youtube: "",
    linkedin: "",
    twitter: "",
    instagram: "",
    facebook: "",
  },
  footerLogo: "",
};
